"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var Typo_1 = require("../../Typo");
var styled_1 = require("../styled");
/**
 * @component Renders a progress bar component with customizable text and styling.
 *
 * - The props object containing the following properties:
 * @prop {number} progress: The progress of the bar.
 * @prop {string} text: The text to be displayed next to the progress bar.
 * @prop {React.ReactNode} children: The content to be rendered inside the progress bar.
 * @prop {boolean} isBlock: A boolean indicating whether the progress bar should be displayed as a block element. Defaults to true.
 * @prop {string} blockHeight: The height of the block element. Defaults to "100%".
 * @prop {number} barWidth: The width of the progress bar. Defaults to 100.
 * @return {ReactElement} The rendered progress bar component.
 */
var ProgressBar = function (_a) {
    var progress = _a.progress, text = _a.text, children = _a.children, _b = _a.isBlock, isBlock = _b === void 0 ? true : _b, _c = _a.blockHeight, blockHeight = _c === void 0 ? '100%' : _c, _d = _a.barWidth, barWidth = _d === void 0 ? 100 : _d;
    var genLoader = function () { return (react_1.default.createElement(styled_1.StyledLoaderWrapper, { isBlock: isBlock },
        react_1.default.createElement(styled_1.StyledHorLoader, { barWidth: barWidth },
            react_1.default.createElement(styled_1.StyledHorLoadingBar, { barWidth: barWidth, progress: progress })),
        (text || children) && react_1.default.createElement(Typo_1.SANS_2, { semibold: true }, text || children))); };
    return !isBlock ? (genLoader()) : (react_1.default.createElement(styled_1.StyledLoaderOverlay, { blockHeight: blockHeight }, genLoader()));
};
exports.ProgressBar = ProgressBar;
